module.exports = __webpack_public_path__ + "static/media/intro_character.3fad671e.svg";